import styled from "styled-components";

export const Container = styled.div`
  @media only screen and (max-width: 425px) {
    max-width: 425px;
    margin-left: auto;
    margin-right: auto;
  }
  overflow-x: hidden;
  overflow-y: ${(props) => props.overflowY || "auto"};
  overscroll-behavior-y: contain;
  -webkit-scroll-snap-type: ${(props) => props.scrollSnapType || "y mandatory"};
  scroll-snap-type: ${(props) => props.scrollSnapType || "y mandatory"};
  height: ${(props) => props.height || "100vh"};
  // -ms-overflow-style: none;
  // scrollbar-width: none;
  // &::-webkit-scrollbar {
  //   display: none;
  // }
`;
